import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@tempo-io/sui-tooltip';

const LEFT_OFFSET = 8;

type SelectToolTipProps = {
  label: string;
  toolTip: string;
};

export const SelectToolTip = ({ label, toolTip }: SelectToolTipProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>{label}</div>
        </TooltipTrigger>
        <TooltipContent side="left" sideOffset={LEFT_OFFSET}>
          {toolTip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
